import axios from 'axios'
import { CADASTRAR_EMISSAO_CTE_OS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarrEmissaoCteOS (emissaoCteOS) {

  const url = `${URL}/emissao-cte-os`;
  return dispatch => axios.post(url, emissaoCteOS, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_EMISSAO_CTE_OS,
        payload: response
      })
  );
}
